// script loader
const loadScript = ( src, callback = () => {} ) => {
    const gs = document.createElement( 'script' );
    gs.src = src;
    gs.type = 'text/javascript';
    gs.async = 'true';
    gs.onreadystatechange = callback;
    gs.onload = callback;
    const gst = document.getElementsByTagName( 'script' )[0];
    gst.parentNode.insertBefore( gs, gst );
};

/**
*  found this code somewhere in stack overflow - get a query string param
*  @param {String} name - name of the parameter
*  @returns url parameter if one exists
*/
const getUrlParameter = ( name ) => {
    const parsedname = name.replace( /[\[]/, '\\[' ).replace( /[\]]/, '\\]' );
    const regex = new RegExp( `[\\?&]${parsedname}=([^&#]*)` );
    const results = regex.exec( window.location.search );
    return results === null ? '' : decodeURIComponent( results[1].replace( /\+/g, ' ' ) );
};

/**
*  found this code somewhere in stack overflow - construct a query string from an object
*  @param {Object} params - params to encode
*  @returns url parameter if one exists
*/
const queryParams = ( params ) => {
    return `?${Object.keys( params ).
        map( ( k ) => `${encodeURIComponent( k )}=${encodeURIComponent( params[k] )}` ).
        join( '&' )}`;
};

// TODO -- MOVE TO OWN NPM MODULE

/**
 * get a top level domain
 * @param {String} url - get told from
 * @returns tld
 */
const getTLD = ( ) => {
    const h = ( window.adiData.host.replace( /:\d+/g, '' ) ).split( "." ).reverse();
    return ( h[0] ===
     'com' ) ? [ h[1], h[0] ].join( "." ) : 'advance.net';
};

/**
*  is paywall eneabled for this lmg?
*  @returns if the lmg is paywalled
*/
const getUrlComponent = ( url, prop ) => {
    var a = document.createElement( 'a' );
    a.setAttribute( 'href', url );
    return a[prop];
};

// create a location object containing location settings from adiData or default to window.location
const locationDetails = ( function() {
    const splitHost = window.location.host.split( "." ).length > 1 ? window.location.host.split( "." ).reverse()[2] : window.location.host.split( "." )[0];

    const loc = window.adiData && window.adiData.entryUrl ?
        {
            host: getUrlComponent( window.adiData.entryUrl, 'host' ),
            href: getUrlComponent( window.adiData.entryUrl, 'href' ),
            protocol: getUrlComponent( window.adiData.entryUrl, 'protocol' ),
            pathname: getUrlComponent( window.adiData.entryUrl, 'pathname' ),
            tier: window.adiData.environment === 'uat' ? 'dev' : 'prod',
            tierSuffix: window.adiData.environment === 'uat' ? '-uat' : '',
            origin: getUrlComponent( window.adiData.entryUrl, 'origin' ),
            hash: getUrlComponent( window.adiData.entryUrl, 'hash' ),
        } : Object.assign( {
            tier: ( function( h ) {
                return ( h.match( /-uat|-dev|-stage|^localhost:\d+?$/ ) ) ? 'dev' : 'prod';
            } )( splitHost ), // There are only two 'instances' in Gigya, Production and Dev, anything other than Production is Dev

            tierSuffix: ( function( h ) {
                return ( h.match( /-dev|-stage|^localhost:\d+?$/ ) ) ? '-dev' : ( h.match( /-uat/ ) ) ? '-uat' : '';
            } )( splitHost ), // For LaaS

        }, window.location );

    loc.tld = ( function() {
        var h = ( loc.host.replace( /:\d+/g, '' ) ).split( "." ).reverse();
        return ( h[0] === 'com' ) ? [ h[1], h[0] ].join( "." ) : 'advance.net';
    }() );

    // if ( !affiliateSettings[loc.tld] ) {
    //     loc.tld = 'advance.net';
    // } // HSSN-4344: Default to advance.net on any non-ADI domain, simply so script can execute
    if ( !window.adiData && loc.host.match( /127.0.0.1|^localhost$/ ) ) {
        loc.tier = 'dev';
        loc.tierSuffix = '-dev';
    }
    loc.uri = `https://${loc.host}${loc.pathname}`;
    return loc;
} )();

export {loadScript, getUrlParameter, queryParams, getTLD, getUrlComponent, locationDetails};
